import React from "react";
import ReactDOM from "react-dom";
import "./ConfirmModal.css";

const ConfirmModal = ({ title, message, onConfirm, onCancel, confirmText, cancelText = "CANCEL" }) => {
  const modalContent = (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-container">
        
        <div className="confirm-modal-header">
          <span className="terminal-prefix"></span> {title}
        </div>

        <div className="confirm-modal-body">
          {message}
        </div>

        <div className="confirm-modal-actions">
                    <button className="modal-btn cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="modal-btn confirm" onClick={onConfirm}>
            {confirmText || "OK"}
          </button>

        </div>
        
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmModal;